<span [innerHTML]="categoryHeader(item)"></span>
<mat-list-option [value]="item.report.reportId ? item.report.reportId : item.report.id" [selected]="(item.report.reportId ? item.report.reportId : item.report.id) === selectedId" (click)="selectItem(item.report)" class="report-list-item">
	<span matListItemIcon>
		<mat-icon mat-list-icon class="report-select-icon" svgIcon="{{ selectedId === (item.report.reportId ? item.report.reportId : item.report.id) ? 'acies_check' : 'acies_uncheck' }}"></mat-icon>
	</span>
	<span class="report-text force-14px-font" matListItemLine>{{ item.report.name }}</span>
</mat-list-option>
